import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { hasSpouseDetails, isPersonTravellingWith } from '../../../../../utilities/pages';

function VisaPrepFamilyStep1(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.MARITAL_STATUS}
        label="What is your marital status?"
        value={String(props.maritalStatus).toLowerCase()}
      />
      {props.maritalStatus !== undefined && hasSpouseDetails(props.maritalStatus) ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_NATIONALITY}
            value={props.spouseNationality}
            label={'Spouse: Nationality'}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_SAME_NATIONALITY}
            label={'Spouse: Have they always had the same nationality?'}
            value={boolToYesNo(props.spouseSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_FAMILY_NAME}
            value={props.spouseFamilyName}
            label={'Spouse: Family Name'}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_GIVEN_NAME}
            value={props.spouseGivenName}
            label={'Spouse: Given Name'}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_DOB}
            label={'Spouse: Date of Birth'}
            value={props.spouseDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_LIVING_WITH}
            label={'Does your spouse / partner currently live with you?'}
            value={boolToYesNo(props.spouseLivingWith)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_TRAVELLING_WITH}
            label={'Spouse: Is this person travelling with you?'}
            value={props.spouseTravellingWith}
          />
          {isPersonTravellingWith(props.spouseTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.SPOUSE_UK_VISA}
                label={'Spouse: Do they have a visa for the UK?'}
                value={boolToYesNo(props.spouseUkVisa)}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.SPOUSE_HAS_PASSPORT}
                label={'Spouse: Do they have a Passport or Travel Document?'}
                value={boolToYesNo(props.spouseHasPassport)}
              />
              {props.spouseHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.SPOUSE_PASSPORT_NUMBER}
                  value={props.spousePassportNumber}
                  label={'Spouse: Current Passport or Travel Document Number:'}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep1;
